import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Header
    'header.tagline': 'Soluzioni di packaging B2B che uniscono estetica, funzionalit\u00e0 e sostenibilit\u00e0',
    'header.about': 'Chi Siamo',
    'header.catalog': 'Catalogo Prodotti',
    'header.certifications': 'Certificazioni',
    'header.news': 'News',
    'header.quote': 'Contattaci',
    // Search
    'search.placeholder': 'Cerca un prodotto...',
    'search.hint': 'Digita per cercare tra i nostri prodotti (nome, categoria, descrizione).',
    'search.noResults': 'Nessun prodotto trovato. Prova con un altro termine.',
    // Hero
    'hero.title1': 'Soluzioni di',
    'hero.title2': 'packaging',
    'hero.title3': 'per ogni esigenza',
    'hero.desc': 'Dal 2011 Cellophane & Paper offre solo soluzioni di confezionamento professionale B2B che uniscono estetica, funzionalit\u00e0 e sostenibilit\u00e0 per il settore alimentare e non solo.',
    'hero.catalog': 'Catalogo Prodotti',
    'hero.requestQuote': 'Richiedi Preventivo',
    'hero.downloadPdf': 'Scarica Catalogo Completo (PDF)',
    // Highlights
    'highlights.moca': 'Certificati M.O.C.A.',
    'highlights.mocaDesc': 'Materiali a contatto alimentare',
    'highlights.since': 'Dal 2011',
    'highlights.sinceDesc': 'Esperienza nel packaging',
    'highlights.certified': '100% Produzione certificata',
    'highlights.certifiedDesc': 'Qualit\u00e0 Made in Italy',
    // Categories
    'categories.badge': 'I nostri prodotti',
    'categories.title': 'Esplora il catalogo',
    'categories.desc': 'Soluzioni complete per il confezionamento alimentare, floreale e decorativo',
    // Catalog banner
    'catalog.title': 'Catalogo Prodotti C&P 2026',
    'catalog.desc': 'Sfoglia il catalogo completo con oltre 80 pagine: tutti i nostri prodotti, materiali, formati e specifiche tecniche in un unico documento.',
    'catalog.download': 'Scarica il Catalogo PDF',
    // Featured
    'featured.badge': 'In evidenza',
    'featured.title': 'I nostri prodotti principali',
    'featured.desc': 'Scopri la gamma Cellophane & Paper per il confezionamento professionale',
    'featured.viewAll': 'Vedi tutti i prodotti',
    // Featured products section (homepage, admin-configurable)
    'featuredSection.badge': 'In evidenza',
    'featuredSection.title': 'Prodotti in Evidenza',
    'featuredSection.subtitle': 'Una selezione dei nostri prodotti più richiesti, scelti per te',
    'featuredSection.discover': 'Scopri',
    'featuredSection.viewAll': 'Vedi tutto il catalogo',
    'featuredSection.prev': 'Precedente',
    'featuredSection.next': 'Successivo',
    'featuredSection.goTo': 'Vai alla slide',
    // About section (home)
    'about.badge': 'Chi siamo',
    'about.title': 'La tua soluzione di packaging professionale B2B',
    'about.desc': 'Cellophane & Paper nasce nel 2011 come azienda specializzata nella produzione e distribuzione di materiali per il confezionamento. Oggi serviamo centinaia di aziende in tutta Italia.',
    'about.more': 'Scopri di pi\u00f9',
    // Sustainability
    'sustainability.badge': 'Sostenibilit\u00e0',
    'sustainability.title': 'Il nostro impegno per l\'ambiente',
    'sustainability.desc': 'Investiamo in materiali biodegradabili e compostabili per un futuro sostenibile',
    'sustainability.recyclable': 'Riciclabile',
    'sustainability.recyclableDesc': 'PPL e alluminio completamente riciclabili nella differenziata',
    'sustainability.compostable': 'Compostabile',
    'sustainability.compostableDesc': 'Cellophane e carta certificati compostabili',
    'sustainability.certified': 'Certificato',
    'sustainability.certifiedDesc': 'Tutti i materiali certificati M.O.C.A. per contatto alimentare',
    // CTA
    'cta.title': 'Hai bisogno di una soluzione personalizzata?',
    'cta.desc': 'Contattaci per un preventivo gratuito e senza impegno',
    'cta.button': 'Richiedi preventivo gratuito',
    // Footer
    'footer.products': 'Prodotti',
    'footer.company': 'Azienda',
    'footer.contacts': 'Contatti',
    'footer.rights': '\u00a9 2026 Cellophane & Paper S.r.l. Tutti i diritti riservati.',
    'footer.credit': 'Sito realizzato da',
    'footer.privacy': 'Privacy',
    'footer.cookie': 'Cookie',
    // Products page
    'products.all': 'Tutti i Prodotti',
    'products.search': 'Cerca prodotti...',
    'products.filter': 'Filtra',
    'products.noResults': 'Nessun prodotto trovato',
    // Product card
    'product.recyclable': 'Riciclabile',
    'product.compostable': 'Compostabile',
    'product.reusable': 'Riutilizzabile',
    'product.quote': 'Preventivo',
    'product.added': 'Aggiunto',
    'product.new': 'Nuovo',
    'product.featured': 'In evidenza',
    'product.eco': 'Eco',
    // Contact form
    'contact.badge': 'Contattaci',
    'contact.title': 'Richiedi informazioni o un preventivo',
    'contact.desc': 'Compila il modulo e ti risponderemo al pi\u00f9 presto',
    'contact.name': 'Nome',
    'contact.surname': 'Cognome',
    'contact.phone': 'Telefono',
    'contact.email': 'Email',
    'contact.vat': 'Partita IVA',
    'contact.subject': 'Argomento',
    'contact.message': 'Messaggio',
    'contact.send': 'Invia messaggio',
    'contact.sending': 'Invio in corso...',
    'contact.success': 'Messaggio inviato!',
    'contact.successDesc': 'Grazie per averci contattato. Ti risponderemo al pi\u00f9 presto.',
    'contact.error': 'Si \u00e8 verificato un errore. Riprova o contattaci telefonicamente al 0975.331875.',
    'contact.another': 'Invia un altro messaggio',
    'contact.selectSubject': 'Seleziona un argomento',
    'contact.subjectQuote': 'Richiesta preventivo',
    'contact.subjectInfo': 'Informazioni sui prodotti',
    'contact.subjectSamples': 'Richiesta campioni',
    'contact.subjectCustom': 'Stampa personalizzata',
    'contact.subjectCollab': 'Proposta di collaborazione',
    'contact.subjectOther': 'Altro',
    // FAQ
    'faq.badge': 'FAQ',
    'faq.title': 'Domande Frequenti',
    'faq.desc': 'Cerca tra le domande pi\u00f9 comuni sui nostri prodotti',
    'faq.search': 'Cerca nelle FAQ...',
    'faq.all': 'Tutte',
    'faq.noResults': 'Nessuna FAQ trovata per questa ricerca.',
    // Cart
    'cart.title': 'Richiesta Preventivo',
    'cart.empty': 'Il carrello \u00e8 vuoto',
    'cart.emptyDesc': 'Aggiungi dei prodotti per richiedere un preventivo',
    'cart.goProducts': 'Vai ai prodotti',
    'cart.selected': 'Prodotti selezionati',
    'cart.yourData': 'I tuoi dati',
    'cart.company': 'Azienda',
    'cart.vat': 'P.IVA',
    'cart.notes': 'Note (es: misura, quantit\u00e0...)',
    'cart.submit': 'Invia richiesta preventivo',
    'cart.submitting': 'Invio...',
    'cart.successTitle': 'Grazie per la tua richiesta!',
    'cart.successDesc': 'Abbiamo ricevuto la tua richiesta di preventivo. Ti contatteremo al pi\u00f9 presto.',
    'cart.continue': 'Continua a esplorare',
    // Certifications
    'cert.title': 'Certificazioni',
    'cert.desc': 'Qualit\u00e0 e conformit\u00e0 certificate per i nostri prodotti',
    'cert.badge': 'Qualit\u00e0 garantita',
    'cert.our': 'Le nostre certificazioni',
    'cert.ourDesc': 'Cellophane & Paper opera nel rispetto degli standard pi\u00f9 elevati di qualit\u00e0 e sicurezza',
    'cert.euBadge': 'Finanziamenti',
    'cert.euTitle': 'Progetti UE',
    'cert.openNew': 'Apri in nuova finestra',
    // Nav
    'nav.home': 'Home',
    'nav.about': 'Chi Siamo',
    'nav.products': 'Catalogo Prodotti',
    'nav.certifications': 'Certificazioni',
    'nav.news': 'News',
    'nav.contacts': 'Contatti',
    // Products page
    'products.title': 'Tutti i Prodotti',
    'products.subtitle': 'Scopri la gamma completa Cellophane & Paper per il confezionamento professionale',
    'products.search': 'Cerca un prodotto...',
    'products.all': 'Tutti',
    'products.found': 'prodotti trovati',
    'products.notFound': 'Nessun prodotto trovato',
    'products.tryAgain': 'Prova con una ricerca diversa',
    // Product detail
    'productDetail.material': 'Materiale',
    'productDetail.features': 'Caratteristiche',
    'productDetail.recyclable': 'Riciclabile',
    'productDetail.compostable': 'Compostabile',
    'productDetail.reusable': 'Riutilizzabile',
    'productDetail.addQuote': 'Aggiungi al preventivo',
    'productDetail.added': 'Aggiunto al preventivo!',
    'productDetail.back': 'Torna ai prodotti',
    'productDetail.notFound': 'Prodotto non trovato',
    'productDetail.zoom': 'Clicca per ingrandire',
    // Chi Siamo
    'about.pageTitle': 'Chi Siamo',
    'about.pageDesc': 'Scopri la storia di Cellophane & Paper',
    // News
    'news.pageTitle': 'News',
    'news.pageDesc': 'Le ultime novit\u00e0 dal mondo Cellophane & Paper',
    'news.readMore': 'Leggi tutto',
  },
  en: {
    // Header
    'header.tagline': 'B2B packaging solutions combining aesthetics, functionality and sustainability',
    'header.about': 'About Us',
    'header.catalog': 'Product Catalog',
    'header.certifications': 'Certifications',
    'header.news': 'News',
    'header.quote': 'Contact us',
    // Search
    'search.placeholder': 'Search a product...',
    'search.hint': 'Type to search our products (name, category, description).',
    'search.noResults': 'No products found. Try a different term.',
    // Hero
    'hero.title1': 'Packaging',
    'hero.title2': 'solutions',
    'hero.title3': 'for every need',
    'hero.desc': 'Since 2011, Cellophane & Paper offers professional B2B packaging solutions combining aesthetics, functionality and sustainability for the food industry and beyond.',
    'hero.catalog': 'Product Catalog',
    'hero.requestQuote': 'Request a Quote',
    'hero.downloadPdf': 'Download Full Catalog (PDF)',
    // Highlights
    'highlights.moca': 'M.O.C.A. Certified',
    'highlights.mocaDesc': 'Food contact materials',
    'highlights.since': 'Since 2011',
    'highlights.sinceDesc': 'Packaging expertise',
    'highlights.certified': '100% Certified Production',
    'highlights.certifiedDesc': 'Made in Italy Quality',
    // Categories
    'categories.badge': 'Our products',
    'categories.title': 'Explore the catalog',
    'categories.desc': 'Complete solutions for food, floral and decorative packaging',
    // Catalog banner
    'catalog.title': 'C&P Product Catalog 2026',
    'catalog.desc': 'Browse the complete catalog with over 80 pages: all our products, materials, formats and technical specifications in one document.',
    'catalog.download': 'Download Catalog PDF',
    // Featured
    'featured.badge': 'Featured',
    'featured.title': 'Our main products',
    'featured.desc': 'Discover the Cellophane & Paper range for professional packaging',
    'featured.viewAll': 'View all products',
    // About section (home)
    'about.badge': 'About us',
    'about.title': 'Your professional B2B packaging solution',
    'about.desc': 'Cellophane & Paper was founded in 2011 as a company specialized in the production and distribution of packaging materials. Today we serve hundreds of businesses across Italy.',
    'about.more': 'Learn more',
    // Sustainability
    'sustainability.badge': 'Sustainability',
    'sustainability.title': 'Our commitment to the environment',
    'sustainability.desc': 'We invest in biodegradable and compostable materials for a sustainable future',
    'sustainability.recyclable': 'Recyclable',
    'sustainability.recyclableDesc': 'PPL and aluminum fully recyclable in sorted waste',
    'sustainability.compostable': 'Compostable',
    'sustainability.compostableDesc': 'Cellophane and paper certified compostable',
    'sustainability.certified': 'Certified',
    'sustainability.certifiedDesc': 'All materials M.O.C.A. certified for food contact',
    // CTA
    'cta.title': 'Need a custom solution?',
    'cta.desc': 'Contact us for a free, no-obligation quote',
    'cta.button': 'Request free quote',
    // Footer
    'footer.products': 'Products',
    'footer.company': 'Company',
    'footer.contacts': 'Contacts',
    'footer.rights': '\u00a9 2026 Cellophane & Paper S.r.l. All rights reserved.',
    'footer.credit': 'Website developed by',
    'footer.privacy': 'Privacy',
    'footer.cookie': 'Cookie',
    // Products page
    'products.all': 'All Products',
    'products.search': 'Search products...',
    'products.filter': 'Filter',
    'products.noResults': 'No products found',
    // Product card
    'product.recyclable': 'Recyclable',
    'product.compostable': 'Compostable',
    'product.reusable': 'Reusable',
    'product.quote': 'Quote',
    'product.added': 'Added',
    'product.new': 'New',
    'product.featured': 'Featured',
    'product.eco': 'Eco',
    // Contact form
    'contact.badge': 'Contact us',
    'contact.title': 'Request information or a quote',
    'contact.desc': 'Fill in the form and we will reply as soon as possible',
    'contact.name': 'First Name',
    'contact.surname': 'Last Name',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.vat': 'VAT Number',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.send': 'Send message',
    'contact.sending': 'Sending...',
    'contact.success': 'Message sent!',
    'contact.successDesc': 'Thank you for contacting us. We will reply as soon as possible.',
    'contact.error': 'An error occurred. Please try again or call us at 0975.331875.',
    'contact.another': 'Send another message',
    'contact.selectSubject': 'Select a subject',
    'contact.subjectQuote': 'Quote request',
    'contact.subjectInfo': 'Product information',
    'contact.subjectSamples': 'Sample request',
    'contact.subjectCustom': 'Custom printing',
    'contact.subjectCollab': 'Collaboration proposal',
    'contact.subjectOther': 'Other',
    // FAQ
    'faq.badge': 'FAQ',
    'faq.title': 'Frequently Asked Questions',
    'faq.desc': 'Search among the most common questions about our products',
    'faq.search': 'Search FAQ...',
    'faq.all': 'All',
    'faq.noResults': 'No FAQ found for this search.',
    // Cart
    'cart.title': 'Quote Request',
    'cart.empty': 'Your cart is empty',
    'cart.emptyDesc': 'Add products to request a quote',
    'cart.goProducts': 'Go to products',
    'cart.selected': 'Selected products',
    'cart.yourData': 'Your details',
    'cart.company': 'Company',
    'cart.vat': 'VAT Number',
    'cart.notes': 'Notes (e.g. size, quantity...)',
    'cart.submit': 'Submit quote request',
    'cart.submitting': 'Submitting...',
    'cart.successTitle': 'Thank you for your request!',
    'cart.successDesc': 'We have received your quote request. We will contact you shortly.',
    'cart.continue': 'Continue browsing',
    // Certifications
    'cert.title': 'Certifications',
    'cert.desc': 'Certified quality and compliance for our products',
    'cert.badge': 'Guaranteed quality',
    'cert.our': 'Our certifications',
    'cert.ourDesc': 'Cellophane & Paper operates in compliance with the highest quality and safety standards',
    'cert.euBadge': 'Funding',
    'cert.euTitle': 'EU Projects',
    'cert.openNew': 'Open in new window',
    // Nav
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.products': 'Product Catalog',
    'nav.certifications': 'Certifications',
    'nav.news': 'News',
    'nav.contacts': 'Contacts',
    // Products page
    'products.title': 'All Products',
    'products.subtitle': 'Discover the complete Cellophane & Paper range for professional packaging',
    'products.search': 'Search a product...',
    'products.all': 'All',
    'products.found': 'products found',
    'products.notFound': 'No products found',
    'products.tryAgain': 'Try a different search',
    // Product detail
    'productDetail.material': 'Material',
    'productDetail.features': 'Features',
    'productDetail.recyclable': 'Recyclable',
    'productDetail.compostable': 'Compostable',
    'productDetail.reusable': 'Reusable',
    'productDetail.addQuote': 'Add to quote',
    'productDetail.added': 'Added to quote!',
    'productDetail.back': 'Back to products',
    'productDetail.notFound': 'Product not found',
    'productDetail.zoom': 'Click to enlarge',
    // Chi Siamo
    'about.pageTitle': 'About Us',
    'about.pageDesc': 'Discover the Cellophane & Paper story',
    // News
    'news.pageTitle': 'News',
    'news.pageDesc': 'Latest news from Cellophane & Paper',
    'news.readMore': 'Read more',
    // Featured products section (homepage, admin-configurable)
    'featuredSection.badge': 'Featured',
    'featuredSection.title': 'Featured Products',
    'featuredSection.subtitle': 'A selection of our most requested products, chosen for you',
    'featuredSection.discover': 'Discover',
    'featuredSection.viewAll': 'View the full catalog',
    'featuredSection.prev': 'Previous',
    'featuredSection.next': 'Next',
    'featuredSection.goTo': 'Go to slide',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('cp_lang') || 'it';
  });

  useEffect(() => {
    localStorage.setItem('cp_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    return (translations[lang] && translations[lang][key]) || translations.it[key] || key;
  };

  const toggleLang = () => {
    setLang(prev => prev === 'it' ? 'en' : 'it');
  };

  // Helper: get localized field from DB object
  // Usage: loc(product, 'name') returns product.name_en if EN and available, else product.name
  const loc = (obj, field) => {
    if (!obj) return '';
    if (lang === 'en') {
      const enField = field + '_en';
      if (obj[enField] && obj[enField].trim()) return obj[enField];
    }
    return obj[field] || '';
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, loc }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
